"use client";

import Image, { ImageProps } from "next/image";

import css from "./theme-image.module.css";

type Props = Omit<ImageProps, "src" | "priority" | "loading"> & {
  srcLight: string;
  srcDark: string;
};

export const ThemeImage = (props: Props) => {
  const { srcLight, srcDark, alt, ...rest } = props;

  return (
    <>
      <span className={css.imgLight}>
        <Image alt={alt} {...rest} src={srcLight} />
      </span>
      <span className={css.imgDark}>
        <Image alt={alt} {...rest} src={srcDark} />
      </span>
    </>
  );
};
